import React from "react";
import {
  Legend,
  RadioButton,
  RadioGroup,
  Alert,
} from "@americanexpress/dls-react";
import FormField from "../../Common/FormField";
import { GENDER, MALE, FEMALE, GENDER_COUNTRY_EXCLUDE_LIST } from "../../Common/constants";
import { useCountry } from "../CountryContext";
import { useUniqueId } from "../../../hooks/useUniqueId";
import { useTranslation } from "react-i18next";

const PABirthDetails = ({ formik }) => {
  const { t } = useTranslation("common");
  const { selectedCountry = "" } = useCountry() || {};
  const baseId = useUniqueId("pa-birth-details");
  const isPersonalIdEntered = !!formik.values.personalIdNumber;

  return (
    <div className="row">
        <FormField
          id="cityOfBirth"
          name="cityOfBirth"
          label={t("newuser.cityOfBirth")}
          colmd="col-md-3"
          value={formik.values.cityOfBirth}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            !isPersonalIdEntered &&
            formik.touched.cityOfBirth &&
            formik.errors.cityOfBirth
          }
        />
        <FormField
          id="countryOfBirth"
          name="countryOfBirth"
          label={t("newuser.countryOfBirth")}
          colmd="col-md-3"
          value={formik.values.countryOfBirth}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            !isPersonalIdEntered &&
            formik.touched.countryOfBirth &&
            formik.errors.countryOfBirth
          }
        />

        {!GENDER_COUNTRY_EXCLUDE_LIST.has(selectedCountry) &&
          <div className="col-md-4 col-xs-12 pad-2-b">
            <RadioGroup
              className="row"
              value={formik.values.gender}
              onChange={(event) =>
                formik.setFieldValue(GENDER, event?.target?.value)
              }
              name={`${baseId}-${GENDER}`}
              onBlur={formik.handleBlur}
            >
              <Legend>{t("newuser.gender")}</Legend>
              <RadioButton
                id={`${baseId}-${MALE}`}
                label={t("newuser.male")}
                value={MALE}
                className="col-md-4 col-xs-6 pad-0-l"
                checked={formik.values.gender === MALE}
              />
              <RadioButton
                id={`${baseId}-${FEMALE}`}
                label={t("newuser.female")}
                value={FEMALE}
                className="col-md-4 col-xs-6"
                checked={formik.values.gender === FEMALE}
              />
            </RadioGroup>
            {formik.touched.gender && formik.errors.gender && (
              <Alert status="error">{formik.errors.gender}</Alert>
            )}
          </div>
        }
      </div>
  );
};
export default PABirthDetails;
